import { useState } from 'react'
import RecordPage, { AboutCard, RecordTimeline, AssociationsColumn } from './RecordPage.jsx'
import ActivityComposer from './ActivityComposer.jsx'
import { buildGroups } from './recordAssociations.js'
import DriveLinksField from './DriveLinksField.jsx'
import EmailPanel from './EmailPanel.jsx'
import { Button } from '../ds/index.js'

export default function ContactRecord({ contact, defs, activities, associations = [], recordsByToken = {}, candidatesByType = {}, users, usersById, onChangeField, onBack, onOpenToken, onLink, onUnlink, onAddActivity, onLogEmail, onDelete, emailTemplates = [], sender = null }) {
  const [confirmDelete, setConfirmDelete] = useState(false)
  const selfToken = `contact:${contact.id}`
  const title = `${contact.firstName || ''} ${contact.lastName || ''}`.trim() || 'Contact'
  const groups = buildGroups(selfToken, associations, recordsByToken, { onOpenToken, candidatesByType, onLink, onUnlink }, [
    { title: 'Companies', type: 'company', label: (r) => r.name || '—', sub: (r) => r.domain || '' },
    { title: 'Engagements', type: 'engagement', label: (r) => r.title || '—', sub: (r) => r.org || '' },
    { title: 'Tasks', type: 'task', label: (r) => r.title || '—', sub: () => '' },
  ])
  const timeline = <RecordTimeline activities={activities} usersById={usersById} composer={<ActivityComposer onAdd={onAddActivity} />} />
  const actions = (
    <Button variant="danger" size="sm" onClick={() => setConfirmDelete(true)}>Delete</Button>
  )
  return (
    <RecordPage
      objectChip="Contact" title={title} onBack={onBack} actions={actions}
      left={
        <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
          <AboutCard defs={defs} record={contact} users={users} onChange={onChangeField} />
          <DriveLinksField links={contact.driveLinks || []} onSave={(next) => onChangeField('driveLinks', next, true)} />
        </div>
      }
      center={{
        overview: (
          <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
            {confirmDelete && (
              <div style={{ border: '1px solid var(--color-danger)', borderRadius: 'var(--radius-lg)', padding: 16 }}>
                <div style={{ fontSize: 13, color: 'var(--color-white)', marginBottom: 8 }}>Delete this contact?</div>
                <ul style={{ margin: '0 0 12px', paddingLeft: 18, fontSize: 12.5, color: 'var(--color-muted)', lineHeight: 1.8 }}>
                  <li>{associations.length} linked record{associations.length === 1 ? '' : 's'} will be unlinked</li>
                  <li>{activities.length} timeline entr{activities.length === 1 ? 'y' : 'ies'} will be deleted</li>
                  <li>The email address becomes reusable for a new contact</li>
                </ul>
                <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
                  <button onClick={() => setConfirmDelete(false)} className="btn btn-ghost" style={{ fontSize: 12, padding: '7px 12px' }}>Cancel</button>
                  <Button variant="danger" size="sm" onClick={onDelete}>Delete contact</Button>
                </div>
              </div>
            )}
            <EmailPanel contactEmail={contact.email} onLogEmail={onLogEmail} templates={emailTemplates} contact={contact} sender={sender} />
            {timeline}
          </div>
        ),
        activity: timeline,
      }}
      right={<AssociationsColumn groups={groups} />}
    />
  )
}
